<div class="accordion" id="accordionSummaryVehicle">
  <button
    *ngIf="!readOnly"
    class="sidebar__trigger"
    data-bs-toggle="collapse"
    data-bs-target="#collapseSummaryVehicle"
    aria-expanded="true"
    aria-controls="collapseSummaryVehicle"
  >
    <h5 class="h5 sidebar__section-title">
      {{ 'sharedModule.bkgSummaryVehicle.yourVehicle' | translate }}
    </h5>
  </button>
  <h5 *ngIf="readOnly" class="h5 sidebar__section-title">
    {{ 'sharedModule.bkgSummaryVehicle.yourVehicle' | translate }}
  </h5>
  <div
    id="collapseSummaryVehicle"
    class="accordion-collapse collapse show"
    data-bs-parent="#accordionSummaryVehicle"
  >
    <div class="accordion-body">
      <div class="sidebar__content">
        <div class="sidebar__content-item">
          <strong>{{ vehicle?.plate }}</strong>
          <strong *ngIf="vehicle?.km"> - {{ vehicle?.km | number }}Km </strong>
          <span
            *ngIf="!readOnly"
            (click)="onClickModifyVehicleKm()"
            class="underline-link"
            >({{ 'sharedModule.bkgSummaryVehicle.edit' | translate }})</span
          >
        </div>

        <div class="sidebar__price-item">
          <span [class.sidebar__price-item-text]="!readOnly">{{
            vehicle?.vehicle_information &&
            vehicle?.vehicle_information.make_description
              ? vehicle?.vehicle_information.make_description +
                ' ' +
                vehicle?.vehicle_information.model_description
              : vehicle?.type
          }}</span>
          <img
            *ngIf="!readOnly && isRegisteredVehicle"
            (click)="onClickModifyVehicle()"
            src="assets/images/icons/edit.svg"
            class="sidebar__price-item-image"
          />
          <img
            *ngIf="!readOnly"
            (click)="onClickChangeVehicle(false)"
            src="assets/images/icons/close.svg"
            class="sidebar__price-item-image"
          />
        </div>


        <div *ngIf="!readOnly" class="sidebar__content-action">
          <a (click)="onClickChangeVehicle(true)">{{
            'sharedModule.bkgSummaryVehicle.modify' | translate
          }}</a>
        </div>
      </div>
    </div>
  </div>
</div>
